import { render } from "./File.vue?vue&type=template&id=7c0df149&scoped=true"
const script = {}

import "./File.vue?vue&type=style&index=0&id=7c0df149&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c0df149"]])

export default __exports__